export default __webpack_public_path__ + "static/Lato-Regular-77ca2742388f408c3be7d0ec3e7dc392.woff";